"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _reactI18next = require("react-i18next");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var translateNs = 'pc-matching:IntroText';

var IntroText = function IntroText(_ref) {
  var user = _ref.user,
      _ref$newUser = _ref.newUser,
      newUser = _ref$newUser === void 0 ? false : _ref$newUser;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    className: _styleModule.default.content,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: _styleModule.default.welcome,
      children: [newUser ? t("".concat(translateNs, ".greetNew")) : t("".concat(translateNs, ".greet")), "\xA0", user ? user : '']
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      component: "h1",
      className: _styleModule.default.headline,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        children: t("".concat(translateNs, ".description_0"))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      component: "h1",
      className: _styleModule.default.headline,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        children: t("".concat(translateNs, ".description"))
      })
    })]
  });
};

var _default = /*#__PURE__*/_react.default.memo(IntroText);

exports.default = _default;